// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminQuoteThresholds = (client) => ({
    /**
     * `POST /admin/quote-thresholds`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/admin/quote-thresholds/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/quote-thresholds", { method: "POST", body, query, headers }),
    /**
     * `DELETE /admin/quote-thresholds/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminDeleteQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/admin/quote-thresholds/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/admin/quote-thresholds/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /admin/quote-thresholds`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminListQuoteThresholds
     * @source packages/medusa-plugin-moq-v2/src/api/admin/quote-thresholds/route.ts
     */
    list: (query, headers) => client.fetch("/admin/quote-thresholds", { method: "GET", query, headers }),
    /**
     * `GET /admin/quote-thresholds/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminGetQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/admin/quote-thresholds/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/quote-thresholds/:id", [id]), { method: "GET", query, headers }),
    /**
     * `PUT /admin/quote-thresholds/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminUpdateQuoteThreshold
     * @source packages/medusa-plugin-moq-v2/src/api/admin/quote-thresholds/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/admin/quote-thresholds/:id", [id]), { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=quote-thresholds.js.map